module.exports = __webpack_public_path__ + "img/no-following.2f65fa7d.png";